module.exports = __webpack_public_path__ + "img/design5.1064b931.png";